<template>
	<header>
		<div class="container-fluid clearfix">
			<router-link to="/" class="logo">
				<span class="hidden">Marion Création - Accueil</span>
				<img src="/image/logo-blanc.png" class="img-fluid" alt="Marion Création" />
			</router-link>
			<div class="header-nav-wrapper">
				<div class="header-top">
					<router-link to="/contact" class="header-tel">02 51 87 66 06</router-link>
					<router-link
						to="/contact"
						class="header-mail email"
						data-user="choveaumarion"
						data-website="gmail.com"
					>
						<span class="hidden">L'adresse email de Marion Création</span>
					</router-link>
				</div>
				<nav>
					<ul class="nav">
						<li>
							<router-link to="/">
								<span>Présentation</span>
							</router-link>
						</li>
						<li>
							<router-link to="/realisation">
								<span>Réalisations</span>
							</router-link>
						</li>
						<li>
							<router-link to="/contact">
								<span>Contact</span>
							</router-link>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	</header>
</template>

<script>
export default {
	name: "Header",
	props: {}
};
</script>
